import { Component } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { CommonEventService } from '../services/common-event.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-custom-quote-component-procurement',
  templateUrl: './custom-quote-component-procurement.component.html',
  styleUrls: ['./custom-quote-component-procurement.component.css']
})
export class CustomQuoteComponentProcurementComponent {
  showPurchaseData = true;
  okayToBuyCount:any;
  resolveData:any;
  closeResult: string = '';
  postConversation:any;
  assistSubmitMsg = false;
  selectedResolId:any;
  resolveDataDuplicate:any;
  selectedResolObj :any;
  level1Errors :any = [];
  conversionData:any;
  resolveIssueId:any = '';
  resolveSubIssueId:any = '';
  selectedMpnToResolve:any='';
  selectedItemNumToResolve:any='';
  isPassive:any='';
  resolveIssueName:any='';
  resolvedLineItemUpdatedObj:any={};
  resoveLineItemIsConsigned:any='';
  resolveModifiedValueMap:any;
  resolveModifiedValueMapObj:any={};
  selectedResolveIssueObj:any={};
  alternateMpnSelected:any;
  selectedResolName:any='';
  arryWithRemovedItem:any=[];
  levelOnevalidationSuccess: boolean = false;
  lineItemToChangeActionObj:any={};
  resolveLineItems:any= {};
  resolveDataSubHeaderIssueName:any='';
  selectedRefDesgToResolve:any='';
  selectedQtyToResolve:any='';
  resolveAltLineItemIsConsigned:any='';
  resolveAltLineItemLotprice:any='';
  flowActivityId:any='';
  selectedDniItem:any={};
  dniItemObjectToFix:any={};
  dniItemMpn:any='';
  dniQty:any='';
  dniRefDes:any='';

  constructor(private modalService: NgbModal,
    public apiService : ApiService,
    public commonService : CommonEventService,
    private router: Router,
    public formBuilder : FormBuilder){

  }
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.commonService.formattingCurrentDateTime();
    var cppInitData={
      "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
    }
    this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
    this.apiService.updateDetailsToDashboard(this.flowActivityId,cppInitData,'ComponentProcurementPage').subscribe((resDatas)=>{
    },err=>{
      console.log(err)
    });
    this.commonService.commonMainObj.sierraRecommendations =[];
    this.commonService.restrictBrowserButtons();
    this.commonService.restrictRefreshButton();
    this.constructCustomBomPricingFinalData();
  }

  ngOnDestroy() {
    this.commonService.destroyRefreshEvent();
  }

  constructCustomBomPricingFinalData(){
    this.commonService.commonMainObj.customBomPricingData['parts'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
    for(var i in this.commonService.commonMainObj.customBomPricingData['parts']){
      let altVendMpn = '';
      if(this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts.length > 0){
        for(var alt in this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts){
          if(this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts[alt].altMPNSource == 'VEND'){
            altVendMpn = this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts[alt].mpn;
          }
          // if(this.commonService.commonMainObj.customBomPricingData['parts'][i].dni != 'DNI'){
          //   if(this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts[alt].altMPNSource == 'VEND' || (this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts[alt].altMPNSource == 'SYS' && this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts[alt]['partDetail']['pricingDetails'][0]['pricingInfo'].source == 'SSK')){
          //     this.commonService.commonMainObj.finalCustomBomPricingData['recommendations'].push(this.commonService.commonMainObj.customBomPricingData['parts'][i]);
          //   }
          // }
        }
      }
      this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateVendMpn = altVendMpn?altVendMpn:'';
      if(this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].action == "Okay to Buy" && this.commonService.commonMainObj.customBomPricingData['parts'][i].dni != 'DNI' && this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable == true){
      this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 0, actionName: 'Okay to buy' }, { actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
      this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 0;
      this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].push(this.commonService.commonMainObj.customBomPricingData['parts'][i]);
      }
      else if(this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].action == "Okay to Buy" && this.commonService.commonMainObj.customBomPricingData['parts'][i].dni != 'DNI' && this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable == false){
      this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 0, actionName: 'Okay to buy' }, { actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
      this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 0;
      this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].push(this.commonService.commonMainObj.customBomPricingData['parts'][i]);
      }
      else if(this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].action == "Okay to Buy" && this.commonService.commonMainObj.customBomPricingData['parts'][i].dni == 'DNI' && this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable == true){
      this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, { actionId: 0, actionName: 'Okay to buy' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
      this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 1;
      this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].push(this.commonService.commonMainObj.customBomPricingData['parts'][i]);
      }
      else if(this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].action == "Okay to Buy" && this.commonService.commonMainObj.customBomPricingData['parts'][i].dni == 'DNI' && this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable == false){
      this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, { actionId: 0, actionName: 'Okay to buy' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
      this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 1;
      this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].push(this.commonService.commonMainObj.customBomPricingData['parts'][i]);
      }
      else if(this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].action=="Issue found" && this.commonService.commonMainObj.customBomPricingData['parts'][i].dni != 'DNI' ){
      this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'].push(this.commonService.commonMainObj.customBomPricingData['parts'][i]);
      }
      // CHANGED below condition according to OFP-1685
      else if(this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].action=="Issue found"  && this.commonService.commonMainObj.customBomPricingData['parts'][i].dni == 'DNI' &&  this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo']['issueSubIssueId']['subIssueId'] == 27 && this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo']['issueSubIssueId']['issueId'] == 177 ){
        if(this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts.length > 0){
          for(var alt in this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts){
            if(this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts[alt].altMPNSource == 'VEND'){
              if(this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts[alt]['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable == true){
                if(this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts[alt]['partDetail']['pricingDetails'][0]['pricingInfo'].lotPrice == 0){
                  this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
                }else{
                  this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, { actionId: 0, actionName: 'Okay to buy' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
                }
              }else{
                if(this.commonService.commonMainObj.customBomPricingData['parts'][i].alternateParts[alt]['partDetail']['pricingDetails'][0]['pricingInfo'].lotPrice == 0){
                  this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
                }else{
                  this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, { actionId: 0, actionName: 'Okay to buy' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
                }
              }
              this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 1;
              this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].push(this.commonService.commonMainObj.customBomPricingData['parts'][i]);
            }
          }
        }
      }
      else if(this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].action=="Issue found"  && this.commonService.commonMainObj.customBomPricingData['parts'][i].dni == 'DNI' &&  this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo']['issueSubIssueId']['subIssueId'] != 27 && this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo']['issueSubIssueId']['issueId'] != 177 ){
        if(this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable == true){
          if(this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].lotPrice == 0){
            this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
          }else{
            this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, { actionId: 0, actionName: 'Okay to buy' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
          }
        }else{
          if(this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].lotPrice == 0){
            this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
          }else{
            this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, { actionId: 0, actionName: 'Okay to buy' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
          }
        }
        this.commonService.commonMainObj.customBomPricingData['parts'][i]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 1;
        this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].push(this.commonService.commonMainObj.customBomPricingData['parts'][i]);
      }  
    }
    this.okayToBuyCount = this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy.length;
    this.removeSpecialCharFromRemarks();
    console.log("this.commonService.commonMainObj.finalCustomBomPricingData",this.commonService.commonMainObj.finalCustomBomPricingData);

    // OFP-1925
    for(var j in this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy']){
      if(this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'][j].alternateParts.length > 0){
        for( var k in this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'][j].alternateParts){
          if(this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'][j].alternateParts[k].altMPNSource == 'VEND' || (this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'][j].alternateParts[k].altMPNSource == 'SYS' && this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'][j].alternateParts[k]['partDetail']['pricingDetails'][0]['pricingInfo'].source == 'SSK')){
            this.commonService.commonMainObj.finalCustomBomPricingData['recommendations'].push(this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'][j]);
          }
        }
      }
    }
    for(var j in this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']){
      if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][j].alternateParts.length > 0){
        for( var k in this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][j].alternateParts){
          if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][j].alternateParts[k].altMPNSource == 'VEND' || (this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][j].alternateParts[k].altMPNSource == 'SYS' && this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][j].alternateParts[k]['partDetail']['pricingDetails'][0]['pricingInfo'].source == 'SSK')){
            this.commonService.commonMainObj.finalCustomBomPricingData['recommendations'].push(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][j]);
          }
        }
      }
    }
    

    if(this.commonService.commonMainObj.finalCustomBomPricingData.recommendations.length > 0){
      console.log("this.commonService.commonMainObj.finalCustomBomPricingData.recommendations",this.commonService.commonMainObj.finalCustomBomPricingData.recommendations);
      setTimeout(()=>{
        $("#sierraSugAltInit").trigger('click');
      },1000);
    }
  }

  removeSpecialCharFromRemarks(){
    for(var dniobj in this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']){
      this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo'].remarks = this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo'].remarks.replace(/\/\//g, '');
      if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueSubIssueId']['subIssueId'] == 51){
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueName'] = 'Cannot Identify Component';
      }else if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueSubIssueId']['subIssueId'] == 30){
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueName'] = 'Long Lead-time';
      }else if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueSubIssueId']['subIssueId'] == 53){
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueName'] = 'Not In Stock';
      }else if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueSubIssueId']['subIssueId'] == 27){
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueName'] = 'Part not available. Found an Alternate MPN';
      }else if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueSubIssueId']['subIssueId'] == 28){
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueName'] = 'Minimum Quantity Issue';
      }else if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueSubIssueId']['subIssueId'] == 52){
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][dniobj]['partDetail']['pricingDetails'][0]['pricingInfo']['issueName'] = 'Obsolete Part';
      }
    }
  }

  showHidePurcData(){
    this.showPurchaseData = this.showPurchaseData?false:true;
  }
  lineItemChange(changedOption:any,actionObj:any,sectionName:any,templateName:any){
    this.lineItemToChangeActionObj = actionObj;
    this.arryWithRemovedItem=[];
    //Move to Okay to buy
    if(changedOption == 0){
      if(sectionName == 'doNotInstall'){
        this.validateLineItemwhenDni(actionObj,templateName,changedOption,sectionName);
        setTimeout(()=>{ 
          if(this.levelOnevalidationSuccess == true){
            this.removeAndRearrangeTheItems(changedOption,this.lineItemToChangeActionObj,sectionName);
            actionObj.partDetail.pricingDetails[0].pricingInfo.isConsignable = false;
            actionObj.dni="";
            actionObj.partDetail.pricingDetails[0].pricingInfo.action = 'Okay to Buy';
            if(actionObj.alternateParts.length > 0){
              for(var i in actionObj.alternateParts){
                if(actionObj.alternateParts[i].altMPNSource == 'VEND' || (actionObj.alternateParts[i].altMPNSource == 'SYS' && actionObj.alternateParts[i]['partDetail']['pricingDetails'][0]['pricingInfo'].source == 'SSK')){
                  this.commonService.commonMainObj.finalCustomBomPricingData['recommendations'].push(actionObj)
                }
              }
            }
            this.commonService.commonMainObj.sierraCustomRecommendations = this.commonService.commonMainObj.finalCustomBomPricingData.recommendations && this.commonService.commonMainObj.finalCustomBomPricingData.recommendations.length>0?this.commonService.commonMainObj.finalCustomBomPricingData.recommendations:[];
            this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].push(actionObj);
            this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
          }else{
            actionObj.partDetail.pricingDetails[0].pricingInfo.selectedAction = 1;
          }
        },this.commonService.commonMainObj.customBomPricingData['parts'].length <=20 ? 5000:this.commonService.commonMainObj.customBomPricingData['parts'].length <= 100 ? 5000 : 10000);
      }else{
        this.removeAndRearrangeTheItems(changedOption,this.lineItemToChangeActionObj,sectionName);
        actionObj.partDetail.pricingDetails[0].pricingInfo.isConsignable = false;
        actionObj.dni="";
        actionObj.partDetail.pricingDetails[0].pricingInfo.action = 'Okay to Buy';
        if(actionObj.alternateParts.length > 0){
          for(var i in actionObj.alternateParts){
            if(actionObj.alternateParts[i].altMPNSource == 'VEND' || (actionObj.alternateParts[i].altMPNSource == 'SYS' && actionObj.alternateParts[i]['partDetail']['pricingDetails'][0]['pricingInfo'].source == 'SSK')){
              this.commonService.commonMainObj.finalCustomBomPricingData['recommendations'].push(actionObj)
            }
          }
        }
        this.commonService.commonMainObj.sierraCustomRecommendations = this.commonService.commonMainObj.finalCustomBomPricingData.recommendations && this.commonService.commonMainObj.finalCustomBomPricingData.recommendations.length>0?this.commonService.commonMainObj.finalCustomBomPricingData.recommendations:[];
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].push(actionObj);

        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }
    }
    //Move to DNI
    else if(changedOption == 1){
      this.removeAndRearrangeTheItems(changedOption,this.lineItemToChangeActionObj,sectionName);
      actionObj.partDetail.pricingDetails[0].pricingInfo.isConsignable = false;
      actionObj.dni="DNI";
      actionObj.partDetail.pricingDetails[0].pricingInfo.action = 'Do Not Install';
      this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].push(actionObj);
      this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
    }
    //Move to Customer Support
    else if(changedOption == 2){ 
      if(sectionName == 'doNotInstall'){
        this.validateLineItemwhenDni(actionObj,templateName,changedOption,sectionName);
        setTimeout(()=>{ 
          if(this.levelOnevalidationSuccess == true){
            this.removeAndRearrangeTheItems(changedOption,this.lineItemToChangeActionObj,sectionName);
            actionObj.partDetail.pricingDetails[0].pricingInfo.isConsignable = false;
            actionObj.dni="";
            actionObj.partDetail.pricingDetails[0].pricingInfo.action = 'CUSTOMER SUPPORT';
            this.commonService.commonMainObj.finalCustomBomPricingData['customerSupport'].push(actionObj);
            this.commonService.commonMainObj.finalCustomBomPricingData['customerSupport'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
          }else{
            actionObj.partDetail.pricingDetails[0].pricingInfo.selectedAction = 1;
          }
        },this.commonService.commonMainObj.customBomPricingData['parts'].length <=20 ? 3000:this.commonService.commonMainObj.customBomPricingData['parts'].length <= 100 ? 5000 : 10000);
      }else{
        this.removeAndRearrangeTheItems(changedOption,this.lineItemToChangeActionObj,sectionName);
        actionObj.partDetail.pricingDetails[0].pricingInfo.isConsignable = false;
        actionObj.dni="";
        actionObj.partDetail.pricingDetails[0].pricingInfo.action = 'CUSTOMER SUPPORT';
        this.commonService.commonMainObj.finalCustomBomPricingData['customerSupport'].push(actionObj);
        this.commonService.commonMainObj.finalCustomBomPricingData['customerSupport'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }
    }
    //Move to I WILL PROVIDE
    else if(changedOption == 3){
      if(sectionName == 'doNotInstall'){
        this.validateLineItemwhenDni(actionObj,templateName,changedOption,sectionName);
        setTimeout(()=>{ 
          if(this.levelOnevalidationSuccess == true){
            this.removeAndRearrangeTheItems(changedOption,this.lineItemToChangeActionObj,sectionName);
            actionObj.partDetail.pricingDetails[0].pricingInfo.isConsignable = true;
            actionObj.dni="";
            actionObj.partDetail.pricingDetails[0].pricingInfo.action = 'I WILL PROVIDE';
            this.commonService.commonMainObj.finalCustomBomPricingData['iWillProvide'].push(actionObj);
            this.commonService.commonMainObj.finalCustomBomPricingData['iWillProvide'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
          }else{
            actionObj.partDetail.pricingDetails[0].pricingInfo.selectedAction = 1;
          }
        },this.commonService.commonMainObj.customBomPricingData['parts'].length <=20 ? 3000:this.commonService.commonMainObj.customBomPricingData['parts'].length <= 100 ? 5000 : 10000);
      }else{
        this.removeAndRearrangeTheItems(changedOption,this.lineItemToChangeActionObj,sectionName);
        actionObj.partDetail.pricingDetails[0].pricingInfo.isConsignable = true;
        actionObj.dni="";
        actionObj.partDetail.pricingDetails[0].pricingInfo.action = 'I WILL PROVIDE';
        this.commonService.commonMainObj.finalCustomBomPricingData['iWillProvide'].push(actionObj);
        this.commonService.commonMainObj.finalCustomBomPricingData['iWillProvide'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }
    }
  }

  removeAndRearrangeTheItems(changedOption:any,actionObj:any,sectionName:any){
    // to remove the items
    for(var li in this.commonService.commonMainObj.finalCustomBomPricingData[sectionName]){
      if(this.commonService.commonMainObj.finalCustomBomPricingData[sectionName][li].itemNo != actionObj.itemNo ){
        this.arryWithRemovedItem.push(this.commonService.commonMainObj.finalCustomBomPricingData[sectionName][li]);
      }
    }
    this.commonService.commonMainObj.finalCustomBomPricingData[sectionName]= this.arryWithRemovedItem;
    //rearrange the options
    const selectedId = Number(changedOption); // Convert to number
    const selectedAction = actionObj.partDetail.pricingDetails[0].pricingInfo.availableActions.find((a: { actionId: number; }) => {
      return a.actionId === selectedId;
    });
    const remainingActions = actionObj.partDetail.pricingDetails[0].pricingInfo.availableActions.filter((a: { actionId: number; }) => a.actionId !== selectedId);
    const originalOrder = [0, 1, 2, 3];
    remainingActions.sort((a: { actionId: number; }, b: { actionId: number; }) => originalOrder.indexOf(a.actionId) - originalOrder.indexOf(b.actionId));
    // Move selected action to the top while maintaining the order of others
    actionObj.partDetail.pricingDetails[0].pricingInfo.availableActions = [selectedAction, ...remainingActions];
  }

  validateLineItemwhenDni(actionObj:any,templateName:any,changedOption:any,sectionName:any){
    let allBomLineItemsInCpp:any=[];
    if(this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy.length > 0){
      for(var ob in this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy){
        allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy[ob])
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall.length > 0){
      for(var dni in this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall){
        if(actionObj.itemNo != '' || actionObj.itemNo != null){
          if(actionObj.itemNo == this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[dni].itemNo){
            allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[dni])
          }
        }else{
          if(actionObj.mpn == this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[dni].mpn){
            allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[dni])
          }
        }
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport.length > 0){
      for(var cs in this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport){
        allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport[cs])
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide.length > 0){
      for(var iwp in this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide){
        allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide[iwp])
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.issueFound.length > 0){
      for(var isf in this.commonService.commonMainObj.finalCustomBomPricingData.issueFound){
        allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.issueFound[isf])
      }
    }
    let itemsTovalidate:any={};
    let validateItemsArray:any=[];
    for(var i in allBomLineItemsInCpp){
      if(allBomLineItemsInCpp[i].itemNo == actionObj.itemNo){
        allBomLineItemsInCpp[i].mpn = actionObj.mpn;
        allBomLineItemsInCpp[i].qtyperBoard = actionObj.qtyperBoard;
        allBomLineItemsInCpp[i].refDes = actionObj.refDes;
      }
      itemsTovalidate={
        "itemNum":allBomLineItemsInCpp[i].itemNo,
        "mpn": allBomLineItemsInCpp[i].mpn,
        "quantity":allBomLineItemsInCpp[i].qtyperBoard,
        "refDesignators": allBomLineItemsInCpp[i].refDes
      }
      validateItemsArray.push(itemsTovalidate);
    }
    this.validateLevelOneErrors('dni',validateItemsArray,actionObj,templateName,changedOption,sectionName);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
 
  // resolveLineItem(content:any,selectedIssueObj:any){
  //   if(this.commonService.commonMainObj.userSessionMemberId != null){
  //     this.commonService.sessionPortalLoad();
  //     setTimeout(()=>{
  //       this.apiService.checkUserSessionApi().subscribe((data: any)=>{
  //         if(data.status == 1){
  //           this.resolveLineItemSessionChecked(content,selectedIssueObj);
  //         }
  //       },error =>{
  //         console.log('Error in checking user session', error);
  //       })
  //     },800);
  //   }else{
  //     this.resolveLineItemSessionChecked(content,selectedIssueObj);
  //   }
  // }

  resolveLineItem(content:any,selectedIssueObj:any) {
    this.commonService.sessionPortalLoad();
    this.level1Errors = [];
    this.selectedResolId = '';
    this.resolveDataSubHeaderIssueName='';
    this.selectedResolName ='';
    this.resolveAltLineItemLotprice = '';
    this.assistSubmitMsg = false;
    this.commonService.loadingShow();
    this.selectedResolveIssueObj = selectedIssueObj;
    this.conversionData = '';
    this.resolveIssueId = selectedIssueObj.partDetail.pricingDetails[0].pricingInfo.issueSubIssueId.issueId;
    this.resolveSubIssueId = selectedIssueObj.partDetail.pricingDetails[0].pricingInfo.issueSubIssueId.subIssueId;
    this.selectedMpnToResolve = selectedIssueObj.mpn;
    this.selectedItemNumToResolve = selectedIssueObj.itemNo;
    this.selectedQtyToResolve = selectedIssueObj.qtyperBoard;
    this.selectedRefDesgToResolve = selectedIssueObj.refDes;
    this.resolveIssueName = selectedIssueObj.partDetail.pricingDetails[0].pricingInfo.remarks.replace(/[^a-z0-9\s]/gi, '');
    this.isPassive =selectedIssueObj.partDetail.technicalInfo.isPassive;
    this.resoveLineItemIsConsigned = selectedIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable;
    this.resolveDataSubHeaderIssueName = selectedIssueObj.partDetail.pricingDetails[0].pricingInfo.issueName;
    this.resolveDataDuplicate ={
      'itemNo': this.selectedItemNumToResolve,
      'mpn': this.selectedMpnToResolve,
      'manufacturer':selectedIssueObj.manufacturer,
      'qtyperBoard':selectedIssueObj.qtyperBoard,
      'refDes': selectedIssueObj.refDes,
      'dni':selectedIssueObj.dni
    };
    if(selectedIssueObj.alternateParts.length > 0 ){
      for(var alt in selectedIssueObj.alternateParts){
        if(selectedIssueObj.alternateParts[alt].altMPNSource == 'VEND'){
          this.alternateMpnSelected = selectedIssueObj.alternateParts[alt].mpn;
          this.resolveAltLineItemIsConsigned=selectedIssueObj.alternateParts[alt].partDetail.pricingDetails[0].pricingInfo.isConsignable;
          this.resolveAltLineItemLotprice = selectedIssueObj.alternateParts[alt].partDetail.pricingDetails[0].pricingInfo.lotPrice;
        }
      }
    }

    var resolveDataObj = {
      "isPassive": this.isPassive, 
      "issueId": this.resolveIssueId, 
      "mpnForDirectSubstitute": this.selectedMpnToResolve, 
      "subIssueId": this.resolveSubIssueId 
    }

    this.apiService.getbomIssueResolutions(resolveDataObj).subscribe((resolData: any)=>{
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.sessionPortalLoad();
        setTimeout(()=>{
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              this.commonService.loadingHide();
              this.resolveData = resolData;
              if(this.resolveData.valueMap[1] == 'Okay to proceed with this Alternate MPN'){
                this.resolveData.valueMap[1] = this.resolveData.valueMap[1]+' '+this.alternateMpnSelected;
                this.resolveModifiedValueMapObj = this.resolveData.valueMap;
                // this.resolveModifiedValueMapObj = Object.fromEntries([['0',this.resolveData.valueMap[1]+''+this.alternateMpnSelected], ...Object.entries(this.resolveData.valueMap)]);  
              }else{
                this.resolveModifiedValueMapObj = this.resolveData.valueMap;
              }    
              var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
              modalRef.result.then((result) => {
                this.closeResult = `Closed with: ${result}`;
              }, (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              });
            }
          },error =>{
            console.log('Error in checking user session', error);
          })
        },1000);
      }else{
        this.commonService.loadingHide();
        this.resolveData = resolData;
        if(this.resolveData.valueMap[1] == 'Okay to proceed with this Alternate MPN'){
          this.resolveData.valueMap[1] = this.resolveData.valueMap[1]+' '+this.alternateMpnSelected;
          this.resolveModifiedValueMapObj = this.resolveData.valueMap;
          // this.resolveModifiedValueMapObj = Object.fromEntries([['0',this.resolveData.valueMap[1]+''+this.alternateMpnSelected], ...Object.entries(this.resolveData.valueMap)]);  
        }else{
          this.resolveModifiedValueMapObj = this.resolveData.valueMap;
        }    
        var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
        modalRef.result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }
    },err=>{
      this.commonService.loadingHide();
      console.log(err)
    });
  }

  selectResol(selectedResolObj:any,selectedResol:any,selectedResolName:any){
    if(selectedResolObj){
      this.selectedResolObj = selectedResolObj;
    }
    this.selectedResolId = selectedResol;
    this.selectedResolName = selectedResolName;
    this.level1Errors = [];
    if(selectedResolName == 'Edit / fix the Manufacturer Part Number'){
      setTimeout(()=>{
        var element1:any = document.getElementById('resolve_issue_edit');
        element1.scrollIntoView({ block: 'end',  behavior: 'smooth', inline: 'end'  });  
      },300);
    }
  }

  // proceedWithResol(){
  //   if(!this.selectedResolId){
  //     this.commonService.showtoast('Please choose a resolution option to proceed','warning');
  //     return false;
  //   }
  //   if(this.commonService.commonMainObj.userSessionMemberId != null){
  //     this.commonService.sessionPortalLoad();
  //     setTimeout(()=>{
  //       this.apiService.checkUserSessionApi().subscribe((data: any)=>{
  //         if(data.status == 1){
  //           this.proceedWithResolSessionChecked();
  //         }
  //       },error =>{
  //         console.log('Error in checking user session', error);
  //       })
  //     },800); 
  //   }else{
  //     this.proceedWithResolSessionChecked();
  //   }
  // }

  proceedWithResol(){
    if(!this.selectedResolId){
      this.commonService.showtoast('Please choose a resolution option to proceed','warning');
      return false;
    }
    this.commonService.sessionPortalLoad();
    this.level1Errors = [];
    this.assistSubmitMsg = false;
    if(this.selectedResolName == 'Edit / fix the Manufacturer Part Number'){
      if(!this.resolveDataDuplicate.qtyperBoard || !this.resolveDataDuplicate.mpn || !this.resolveDataDuplicate.refDes){
        var msgTypeText = !this.resolveDataDuplicate.qtyperBoard?'quantity':!this.resolveDataDuplicate.mpn?'MPN':!this.resolveDataDuplicate.refDes?'reference designators':'mandatory fields';
        this.commonService.alertCall("Alert!", 'Please enter '+msgTypeText);
      }else{
        // first run here level1 validation for all the components except those in DNI section
        let allBomItemsWithoutDni = []
        if(this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy.length > 0){
          for(var ob in this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy){
            allBomItemsWithoutDni.push(this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy[ob])
          }
        }
        if(this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport.length > 0){
          for(var cs in this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport){
            allBomItemsWithoutDni.push(this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport[cs])
          }
        }
        if(this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide.length > 0){
          for(var iwp in this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide){
            allBomItemsWithoutDni.push(this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide[iwp])
          }
        }
        if(this.commonService.commonMainObj.finalCustomBomPricingData.issueFound.length > 0){
          for(var isf in this.commonService.commonMainObj.finalCustomBomPricingData.issueFound){
            allBomItemsWithoutDni.push(this.commonService.commonMainObj.finalCustomBomPricingData.issueFound[isf])
          }
        }
        let itemsTovalidate:any={};
        let listOfItemsToValidate:any=[];
        for(var i in allBomItemsWithoutDni){
          if(allBomItemsWithoutDni[i].itemNo == this.selectedResolveIssueObj.itemNo){
            allBomItemsWithoutDni[i].mpn = this.resolveDataDuplicate.mpn;
            allBomItemsWithoutDni[i].qtyperBoard = this.resolveDataDuplicate.qtyperBoard;
            allBomItemsWithoutDni[i].refDes = this.resolveDataDuplicate.refDes;
          }
          itemsTovalidate={
            "itemNum":allBomItemsWithoutDni[i].itemNo ,
            "mpn":allBomItemsWithoutDni[i].mpn,
            "quantity":allBomItemsWithoutDni[i].qtyperBoard,
            "refDesignators":allBomItemsWithoutDni[i].refDes
          }
          listOfItemsToValidate.push(itemsTovalidate);
        }
        // setTimeout(()=>{
          this.validateLevelOneErrors('edit',listOfItemsToValidate,this.resolveDataDuplicate,'','','');
        // },2000);
      }
    }else if(this.selectedResolId && this.selectedResolId == 10){
      // if directSubstitutes is selected
      var substituteLineItemObj ={};
      var finalSubstituteLineItemArr = [];
      substituteLineItemObj={
        'itemNo': this.resolveDataDuplicate.itemNo,
        'manufacturer' : this.resolveDataDuplicate.manufacturer,
        'mpn': this.selectedResolObj.mpn,
        'qtyperBoard': this.resolveDataDuplicate.qtyperBoard,
        'refDes': this.resolveDataDuplicate.refDes,
        'dni':this.resolveDataDuplicate.dni
      }
      finalSubstituteLineItemArr.push(substituteLineItemObj);
      var substituteMpnDataObj:any={
        "boardQuantity" :[this.commonService.commonMainObj.customQtyOfAssemblies] ,
        "items": finalSubstituteLineItemArr
      }
      this.commonService.loadingShow();
      this.apiService.requestForCustomBomPricing(substituteMpnDataObj).subscribe((result:any) =>{
        this.commonService.sessionPortalLoad();
        if(this.commonService.commonMainObj.userSessionMemberId != null){
          this.commonService.sessionPortalLoad();
          setTimeout(()=>{
            this.apiService.checkUserSessionApi().subscribe((data: any)=>{
              this.commonService.loadingHide();
              if(data.status == 1){
                this.populateDataWithResolution10(result);
              }
            },error =>{
              console.log('Error in checking user session', error);
            })
          },1000);
        }else{
          this.populateDataWithResolution10(result);
        }
      },err=>{
        this.commonService.loadingHide();
        this.commonService.alertCall("Alert!", 'Something went wrong, Please try again');
        this.modalService.dismissAll('Save click');
        console.log(err)
      });
    }else{
      //remove that resolveObj from issues found section
      var toRemoveIssueLineItem=[];
      for(var li in this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']){
        if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li].itemNo != this.selectedResolveIssueObj.itemNo ){
          toRemoveIssueLineItem.push(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li]);
        }
      }
      this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']=toRemoveIssueLineItem;
      //remove the resolved item from sierra recommendation popup if present
      if(this.commonService.commonMainObj.sierraCustomRecommendations.length>0){
          this.commonService.commonMainObj.finalCustomBomPricingData.recommendations= this.commonService.commonMainObj.finalCustomBomPricingData.recommendations.filter((item: any) => item !== this.selectedResolveIssueObj);
        }
      // To update aavailableActions
      if(this.selectedResolName == 'Do Not Install'){
        if(this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].issueName != 'Part not available. Found an Alternate MPN'){
          if(this.resoveLineItemIsConsigned == true){
            if(this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].lotPrice == 0){
              this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
            }else{
              this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' },{actionId: 0, actionName: 'Okay to buy'}, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
            }
          }
          else{
            if(this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].lotPrice == 0){
              this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
            }else{
              this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' },{actionId: 0, actionName: 'Okay to buy'}, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
            }
          }          
        }else{
          if(this.resolveAltLineItemIsConsigned == true){
            if(this.resolveAltLineItemLotprice != 0){
              this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' },{actionId: 0, actionName: 'Okay to buy'}, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
            }else{
              this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
            }
          }else{
            if(this.resolveAltLineItemLotprice != 0){
              this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' },{actionId: 0, actionName: 'Okay to buy'}, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
            }else{
              this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
            }
          }
        }
        this.selectedResolveIssueObj.addedRemarks = this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].issueName == 'Long Lead-time'? 'Long Lead-time': this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].issueName == 'Obsolete Part'? 'Obsolete Part':'';
        this.selectedResolveIssueObj.dni="DNI";
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 1;
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].action='Do Not Install';
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable = false;
        this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].push(this.selectedResolveIssueObj) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }else if(this.selectedResolName == 'Customer will supply'){
        this.selectedResolveIssueObj.dni="";
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable = true;
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 3;
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].action='I WILL PROVIDE';
        if(this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].issueName != 'Part not available. Found an Alternate MPN'){
          if(this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].lotPrice == 0){
            this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{actionId: 3, actionName: 'I WILL PROVIDE'},{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
          }else{
            this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{actionId: 3, actionName: 'I WILL PROVIDE'},{actionId: 0, actionName: 'Okay to buy'},{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}]; 
          }
        }else{
          if(this.resolveAltLineItemLotprice != 0){
            this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{actionId: 3, actionName: 'I WILL PROVIDE'},{actionId: 0, actionName: 'Okay to buy'},{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
          }else{
            this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{actionId: 3, actionName: 'I WILL PROVIDE'},{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
          }
        }
        this.commonService.commonMainObj.finalCustomBomPricingData['iWillProvide'].push(this.selectedResolveIssueObj) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['iWillProvide'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }else if(this.selectedResolName == 'Ask Sierra to recommend/find alternate part (Component Engineering Help)'){
        if(this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].issueName != 'Part not available. Found an Alternate MPN'){
          if(this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].lotPrice == 0){
            this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{actionId: 2, actionName: 'CUSTOMER SUPPORT'},{ actionId: 1, actionName: '(DNI) Do Not Install' },{actionId: 3, actionName: 'I WILL PROVIDE'}];
          }else{
            this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 0, actionName: 'Okay to buy'},{ actionId: 1, actionName: '(DNI) Do Not Install' },{actionId: 3, actionName: 'I WILL PROVIDE'}];
          }
        }else{
          if(this.resolveAltLineItemLotprice == 0){
            this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{actionId: 2, actionName: 'CUSTOMER SUPPORT'},{ actionId: 1, actionName: '(DNI) Do Not Install' },{actionId: 3, actionName: 'I WILL PROVIDE'}];
          }else{
            this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 0, actionName: 'Okay to buy'},{ actionId: 1, actionName: '(DNI) Do Not Install' },{actionId: 3, actionName: 'I WILL PROVIDE'}];
          }
        }
        this.selectedResolveIssueObj.addedRemarks = this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].issueName == 'Long Lead-time'? 'Long Lead-time': this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].issueName == 'Obsolete Part'? 'Obsolete Part':'';
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 2;
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].action='CUSTOMER SUPPORT';
        this.selectedResolveIssueObj.dni="";
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable = false;
        this.commonService.commonMainObj.finalCustomBomPricingData['customerSupport'].push(this.selectedResolveIssueObj) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['customerSupport'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }else if(this.selectedResolName == 'Accept the long lead time possibility and ask Sierra to buy these components'){
        if(this.resoveLineItemIsConsigned == true || this.resoveLineItemIsConsigned == null){
          this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 0, actionName: 'Okay to buy' }, { actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
        }else{
          this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 0, actionName: 'Okay to buy' }, { actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
        }
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 0;
        this.selectedResolveIssueObj.dni="";
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].action='Okay to Buy';
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable = false;
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].push(this.selectedResolveIssueObj) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }else{
        // If an alternate is selected
        if(this.resolveAltLineItemIsConsigned == true){
          this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 0, actionName: 'Okay to buy' }, { actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
        }else{
          this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 0, actionName: 'Okay to buy' }, { actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
        }
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 0;
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].action='Okay to Buy';
        this.selectedResolveIssueObj.alternateMpn = this.alternateMpnSelected;
        this.selectedResolveIssueObj.dni="";
        this.selectedResolveIssueObj['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable = false;
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].push(this.selectedResolveIssueObj) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
        if(this.commonService.commonMainObj.finalCustomBomPricingData.recommendations && this.commonService.commonMainObj.finalCustomBomPricingData.recommendations.length > 0){
          this.commonService.commonMainObj.finalCustomBomPricingData.recommendations= this.commonService.commonMainObj.finalCustomBomPricingData.recommendations.filter((item: any) => item !== this.selectedResolveIssueObj);
        }
      }
      this.modalService.dismissAll('Save click');
    }
  }

  populateDataWithResolution10(result:any){
    this.commonService.loadingHide();
    this.resolvedLineItemUpdatedObj = result;
    var issuesObjectAfterRemovingResolvedLineItem =[];
    var resolvedSectionName;
    if(this.resolvedLineItemUpdatedObj['parts'][0].partDetail.pricingDetails[0].pricingInfo.action != 'Issue found'){
      for(var li in this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']){
        if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li].itemNo != this.resolvedLineItemUpdatedObj['parts'][0].itemNo ){
          issuesObjectAfterRemovingResolvedLineItem.push(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li]);
        }
      }
      this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']=issuesObjectAfterRemovingResolvedLineItem;
    }
    resolvedSectionName = this.resolvedLineItemUpdatedObj.parts[0].partDetail.pricingDetails[0].pricingInfo.action == 'Okay to Buy'? 'okayToBuy': this.resolvedLineItemUpdatedObj.parts[0].partDetail.pricingDetails[0].pricingInfo.action == 'Issue found'? 'issueFound': '';
    resolvedSectionName = 'okayToBuy';
    this.populateAvailableActionToResolvedObj(this.resolvedLineItemUpdatedObj,resolvedSectionName);
    this.modalService.dismissAll('Save click');
  }

  populateAvailableActionToResolvedObj(resolvedObj:any, resolvedSectionName:any){
    if( resolvedSectionName == 'okayToBuy'){
      if(resolvedObj['parts'][0].dni != 'DNI' && resolvedObj['parts'][0].partDetail.pricingDetails[0].pricingInfo.isConsignable == true){
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 0, actionName: 'Okay to buy' }, { actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 0;
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].action='Okay to Buy';
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].push(resolvedObj['parts'][0]) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }else if(resolvedObj['parts'][0].dni != 'DNI' && resolvedObj['parts'][0].partDetail.pricingDetails[0].pricingInfo.isConsignable == false){
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 0, actionName: 'Okay to buy' }, { actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 0;
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].action='Okay to Buy';
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].push(resolvedObj['parts'][0]) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }else if(resolvedObj['parts'][0].dni == 'DNI' && resolvedObj['parts'][0].partDetail.pricingDetails[0].pricingInfo.isConsignable == true){
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' },{ actionId: 0, actionName: 'Okay to buy' },{actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 1;
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].action='Do Not Install';
        this.commonService.commonMainObj.finalCustomBomPricingData['dni'].push(resolvedObj['parts'][0]) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['dni'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }else if(resolvedObj['parts'][0].dni == 'DNI' && resolvedObj['parts'][0].partDetail.pricingDetails[0].pricingInfo.isConsignable == false){
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' },{ actionId: 0, actionName: 'Okay to buy' },{actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 1;
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].action='Do Not Install';
        this.commonService.commonMainObj.finalCustomBomPricingData['dni'].push(resolvedObj['parts'][0]) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['dni'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }

    }else if(resolvedSectionName == 'issueFound'){
      if(resolvedObj['parts'][0].dni != 'DNI'){
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'].push(resolvedObj['parts'][0]) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
        this.removeSpecialCharFromRemarks();
      }else if(resolvedObj['parts'][0].dni == 'DNI' && resolvedObj['parts'][0].partDetail.pricingDetails[0].pricingInfo.isConsignable == true){
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 1;
        this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].push(resolvedObj['parts'][0]);
        this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }else if(resolvedObj['parts'][0].dni == 'DNI' && resolvedObj['parts'][0].partDetail.pricingDetails[0].pricingInfo.isConsignable == false){
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
        resolvedObj['parts'][0]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 1;

        this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].push(resolvedObj['parts'][0]);
        this.commonService.commonMainObj.finalCustomBomPricingData['doNotInstall'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }
    }
  }

  validateLevelOneErrors(fromData:any,itemsToValidate:any, lineItemObj:any,templateName:any,changedOption:any,sectionName:any){
    this.commonService.sessionPortalLoad();
    this.resolveLineItems='';
    this.resolvedLineItemUpdatedObj = '';
    this.arryWithRemovedItem=[];
    this.levelOnevalidationSuccess =false;
    let issFnd:any=[];
    for(var li in this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']){
      if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li].itemNo == lineItemObj.itemNo){
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li].mpn = this.selectedMpnToResolve;
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li].qtyperBoard = this.selectedQtyToResolve;
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li].refDes = this.selectedRefDesgToResolve;
        // 
      }
      issFnd.push(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li]);
    }
    this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']=issFnd;
    if(this.commonService.commonMainObj.userSessionMemberId == null){
      this.commonService.loadingShow();
    }
    this.apiService.submitMpnLevel1CheckToResolve(itemsToValidate).subscribe((validatedData: any)=>{
      this.commonService.sessionPortalLoad();
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.loadingShow();
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          setTimeout(()=>{
            this.commonService.loadingHide();
          },this.commonService.commonMainObj.customBomPricingData['parts'].length <=20 ? 3000:this.commonService.commonMainObj.customBomPricingData['parts'].length <= 100 ? 5000 : 10000);
          if(data.status == 1){
            this.validateLevel1ErrorsSessionCheck(fromData,itemsToValidate, lineItemObj,validatedData,templateName,changedOption,sectionName)
          }
        },error =>{
          console.log('Error in checking user session', error);
        })
      },1000);
    }else{
      this.validateLevel1ErrorsSessionCheck(fromData,itemsToValidate, lineItemObj,validatedData,templateName,changedOption,sectionName);
      setTimeout(()=>{
        this.commonService.loadingHide();
      },this.commonService.commonMainObj.customBomPricingData['parts'].length <=20 ? 1500:this.commonService.commonMainObj.customBomPricingData['parts'].length <= 100 ? 3000 : 6000);
    }
    },err=>{
      if(err.error.status == 'Invalid' || err.error.errors){
        this.level1Errors = err.error.errors
        // this.commonService.alertCall("Alert!", err.error.errors);
      }else{
        this.commonService.alertCall("Alert!", 'Something went wrong, Please try again');
      }
    });
  }

  validateLevel1ErrorsSessionCheck(fromData:any,itemsToValidate:any, lineItemObj:any,validatedData:any,content:any,changedOption:any,sectionName:any){
    this.dniItemObjectToFix ='';
    this.dniItemMpn='';
    this.dniQty='';
    this.dniRefDes='';
    if(validatedData){
      for(var k in validatedData){
        if(validatedData[k].itemNumber != '' || validatedData[k].itemNumber != null){
          if(validatedData[k].itemNumber == lineItemObj.itemNo){
            if(validatedData[k].status == 'Success' && validatedData[k].errors.length == 0){
              // this.resolveDataDuplicate.ref_designators = validatedData[k].referenceDesignator.join()
              if(fromData == 'dni'){
                setTimeout(()=>{
                  this.commonService.loadingHide();
                },this.commonService.commonMainObj.customBomPricingData['parts'].length <=20 ? 3000:this.commonService.commonMainObj.customBomPricingData['parts'].length <= 100 ? 5000 : 10000);
                this.levelOnevalidationSuccess = true;
                this.selectedDniItem.errors='';
                $('#errorMsg').text('');
                this.modalService.dismissAll();
              }else{ 
                this.commonService.alertCall('Please wait while we price the component '+ this.resolveDataDuplicate.mpn, 'Component will be added to "Sierra will Purchase" section if issue is resolved.');
                // setTimeout(()=>{
                  var finalLineItem = [];
                  this.resolveLineItems = {
                    'itemNo': validatedData[k].itemNumber ,
                    'manufacturer' : lineItemObj.manufacturer,
                    'mpn': validatedData[k].mpn ,
                    'qtyperBoard': validatedData[k].quantity,
                    'refDes': validatedData[k].referenceDesignator,
                    'dni':fromData == 'edit'?lineItemObj.dni:''
                  }
                  finalLineItem.push(this.resolveLineItems);
                  var resolveLineItemObj:any={
                    "boardQuantity" :[this.commonService.commonMainObj.customQtyOfAssemblies] ,
                    "items": finalLineItem
                  }             
                  this.apiService.requestForCustomBomPricing(resolveLineItemObj).subscribe((result:any) =>{
                    this.commonService.loadingHide();
                    this.resolvedLineItemUpdatedObj = result;
                    var issuesObjectAfterRemovingResolvedLineItem =[];
                    var resolvedSectionName;
                    //on success remove the item from issueFound section and update according to the response              
                    // if(this.resolvedLineItemUpdatedObj['parts'][0].partDetail.pricingDetails[0].pricingInfo.action == 'Issue found'){
                      for(var li in this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']){
                        if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li].itemNo != this.resolvedLineItemUpdatedObj['parts'][0].itemNo ){
                          issuesObjectAfterRemovingResolvedLineItem.push(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li]);
                        }
                      }
                      this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']=issuesObjectAfterRemovingResolvedLineItem;
                    // }                
                    //move to respective section based on resolvedSectionName
                    resolvedSectionName = this.resolvedLineItemUpdatedObj.parts[0].partDetail.pricingDetails[0].pricingInfo.action == 'Okay to Buy'? 'okayToBuy': this.resolvedLineItemUpdatedObj.parts[0].partDetail.pricingDetails[0].pricingInfo.action == 'Issue found'? 'issueFound': ''
                    this.populateAvailableActionToResolvedObj(this.resolvedLineItemUpdatedObj,resolvedSectionName);
                    this.modalService.dismissAll('Save click');
                  },err=>{
                    this.commonService.loadingHide();
                    this.commonService.alertCall("Alert!", 'Something went wrong, Please try again');
                    this.modalService.dismissAll('Save click');
                    console.log(err)
                  });
                // },2000);
              }
            }else if(validatedData[k].errors.length>0){
              this.commonService.loadingHide();
              if(fromData == 'dni'){
                // this.commonService.alertCall("Alert!", validatedData[k].errors); OFP-1717
                this.levelOnevalidationSuccess = false;
                this.selectedDniItem = lineItemObj;
                this.dniItemObjectToFix = this.selectedDniItem;
                this.dniItemMpn= this.selectedDniItem.mpn;
                this.dniQty = this.selectedDniItem.qtyperBoard;
                this.dniRefDes= this.selectedDniItem.refDes;
                this.selectedDniItem.errors = validatedData[k].errors;
                this.selectedDniItem.changedOption= changedOption;
                this.selectedDniItem.sectionName=sectionName;
                if(content != ''){
                  let modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class",backdrop : 'static',keyboard : false})
                  modalRef.result.then((result) => {
                    this.closeResult = `Closed with: ${result}`;
                  }, (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                  });
                }
              }else{
                this.level1Errors = validatedData[k].errors;
              }
            }
          }
        }else if(validatedData[k].mpn == lineItemObj.mpn){
          if(validatedData[k].status == 'Success' && validatedData[k].errors.length == 0){
            if(fromData == 'dni'){
              this.commonService.loadingHide();
              this.levelOnevalidationSuccess = true;
            }else{ 
              this.commonService.alertCall('Please wait while we price the component '+ this.resolveDataDuplicate.mpn, 'Component will be added to "Sierra will Purchase" section if issue is resolved.');
              // setTimeout(()=>{
                var finalLineItem = [];
                this.resolveLineItems = {
                  'itemNo': validatedData[k].itemNumber ,
                  'manufacturer' : lineItemObj.manufacturer,
                  'mpn': validatedData[k].mpn ,
                  'qtyperBoard': validatedData[k].quantity,
                  'refDes': validatedData[k].referenceDesignator,
                  'dni':fromData == 'edit'?lineItemObj.dni:''
                }
                finalLineItem.push(this.resolveLineItems);
                var resolveLineItemObj:any={
                  "boardQuantity" :[this.commonService.commonMainObj.customQtyOfAssemblies] ,
                  "items": finalLineItem
                }             
                this.apiService.requestForCustomBomPricing(resolveLineItemObj).subscribe((result:any) =>{
                  this.commonService.loadingHide();
                  this.resolvedLineItemUpdatedObj = result;
                  var issuesObjectAfterRemovingResolvedLineItem =[];
                  var resolvedSectionName;
                  //on success remove the item from issueFound section and update according to the response              
                  // if(this.resolvedLineItemUpdatedObj['parts'][0].partDetail.pricingDetails[0].pricingInfo.action == 'Issue found'){
                    for(var li in this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']){
                      if(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li].itemNo != this.resolvedLineItemUpdatedObj['parts'][0].itemNo ){
                        issuesObjectAfterRemovingResolvedLineItem.push(this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'][li]);
                      }
                    }
                    this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']=issuesObjectAfterRemovingResolvedLineItem;
                  // }                
                  //move to respective section based on resolvedSectionName
                  resolvedSectionName = this.resolvedLineItemUpdatedObj.parts[0].partDetail.pricingDetails[0].pricingInfo.action == 'Okay to Buy'? 'okayToBuy': this.resolvedLineItemUpdatedObj.parts[0].partDetail.pricingDetails[0].pricingInfo.action == 'Issue found'? 'issueFound': ''
                  this.populateAvailableActionToResolvedObj(this.resolvedLineItemUpdatedObj,resolvedSectionName);
                  this.modalService.dismissAll('Save click');
                },err=>{
                  this.commonService.loadingHide();
                  this.commonService.alertCall("Alert!", 'Something went wrong, Please try again');
                  this.modalService.dismissAll('Save click');
                  console.log(err)
                });
              // },2000);
            }
          }else if(validatedData[k].errors.length>0){
            this.commonService.loadingHide();
            if(fromData == 'dni'){
              this.commonService.alertCall("Alert!", validatedData[k].errors);
            }else{
              this.level1Errors = validatedData[k].errors;
            }
          }
        }
      }
    }
  }

  dniItemIssueModalContinue(actionObj:any){
    if(this.dniItemMpn == actionObj.mpn && this.dniRefDes == actionObj.refDes && this.dniQty == actionObj.qtyperBoard){
      $('#errorMsg').text("Please resolve BOM Line Item issue to Continue");
    }else{
      $('#errorMsg').text('');
    }
    let allBomLineItemsInCpp:any=[];
    
    if(this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy.length > 0){
      for(var ob in this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy){
        allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy[ob])
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall.length > 0){
      for(var dni in this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall){
        if(actionObj.itemNo != '' || actionObj.itemNo != null){
          if(actionObj.itemNo == this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[dni].itemNo){
            allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[dni])
          }
        }else{
          if(actionObj.mpn == this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[dni].mpn){
            allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[dni])
          }
        }
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport.length > 0){
      for(var cs in this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport){
        allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport[cs])
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide.length > 0){
      for(var iwp in this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide){
        allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide[iwp])
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.issueFound.length > 0){
      for(var isf in this.commonService.commonMainObj.finalCustomBomPricingData.issueFound){
        allBomLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.issueFound[isf])
      }
    }
    let itemsTovalidate:any={};
    let validateItemsArray:any=[];
    for(var i in allBomLineItemsInCpp){
      if(allBomLineItemsInCpp[i].itemNo == actionObj.itemNo){
        allBomLineItemsInCpp[i].mpn = actionObj.mpn;
        allBomLineItemsInCpp[i].qtyperBoard = actionObj.qtyperBoard;
        allBomLineItemsInCpp[i].refDes = actionObj.refDes;
      }
      itemsTovalidate={
        "itemNum":allBomLineItemsInCpp[i].itemNo,
        "mpn": allBomLineItemsInCpp[i].mpn,
        "quantity":allBomLineItemsInCpp[i].qtyperBoard,
        "refDesignators": allBomLineItemsInCpp[i].refDes
      }
      validateItemsArray.push(itemsTovalidate);
    }

    this.apiService.submitMpnLevel1CheckToResolve(validateItemsArray).subscribe((validatedData: any)=>{
      for(var k in validatedData){
        if(validatedData[k].itemNumber != '' || validatedData[k].itemNumber != null){
          if(validatedData[k].itemNumber == actionObj.itemNo){
            if(validatedData[k].status == 'Success' && validatedData[k].errors.length == 0){
              //move to respective section
              this.levelOnevalidationSuccess = true;
              this.selectedDniItem.errors='';
              $('#errorMsg').text('');
              if(actionObj.changedOption == 0){
                this.removeAndRearrangeTheItems(actionObj.changedOption,actionObj,actionObj.sectionName);
                actionObj.partDetail.pricingDetails[0].pricingInfo.isConsignable = false;
                actionObj.dni="";
                actionObj.partDetail.pricingDetails[0].pricingInfo.action = 'Okay to Buy';
                actionObj.partDetail.pricingDetails[0].pricingInfo.selectedAction = 0;
                this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].push(actionObj);
                this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
              }
              else if(actionObj.changedOption == 2){ 
                this.removeAndRearrangeTheItems(actionObj.changedOption,this.lineItemToChangeActionObj,actionObj.sectionName);
                actionObj.partDetail.pricingDetails[0].pricingInfo.isConsignable = false;
                actionObj.dni="";
                actionObj.partDetail.pricingDetails[0].pricingInfo.selectedAction = 2;
                actionObj.partDetail.pricingDetails[0].pricingInfo.action = 'CUSTOMER SUPPORT';
                this.commonService.commonMainObj.finalCustomBomPricingData['customerSupport'].push(actionObj);
                this.commonService.commonMainObj.finalCustomBomPricingData['customerSupport'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
              }
              else if(actionObj.changedOption == 3){ 
                this.removeAndRearrangeTheItems(actionObj.changedOption,this.lineItemToChangeActionObj,actionObj.sectionName);
                actionObj.partDetail.pricingDetails[0].pricingInfo.isConsignable = true;
                actionObj.dni="";
                actionObj.partDetail.pricingDetails[0].pricingInfo.selectedAction = 3;
                actionObj.partDetail.pricingDetails[0].pricingInfo.action = 'I WILL PROVIDE';
                this.commonService.commonMainObj.finalCustomBomPricingData['iWillProvide'].push(actionObj);
                this.commonService.commonMainObj.finalCustomBomPricingData['iWillProvide'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
              }
              this.modalService.dismissAll();
            }else if(validatedData[k].errors.length>0){
               $('#errorMsg').text("Please resolve BOM Line Item issue to Continue");
              actionObj.partDetail.pricingDetails[0].pricingInfo.selectedAction = 1;
              this.levelOnevalidationSuccess = false;
              this.selectedDniItem = actionObj;
              this.selectedDniItem.errors = validatedData[k].errors;
              this.selectedDniItem.changedOption= actionObj.changedOption;
              this.selectedDniItem.sectionName=actionObj.sectionName;
            }
          }
        }
      }
    });
  }
  onCancel(){
    for(var item in this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall){
      if(this.dniItemObjectToFix.itemNo == this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[item].itemNo){
        this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[item].mpn = this.dniItemMpn;
        this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[item].refDes = this.dniRefDes;
        this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[item].qtyperBoard = this.dniQty;
      }
    }
    this.modalService.dismissAll();

  }

  submitProceedResol(loadShow:any,mpnData:any){
  }

  proceedToAdditionalComp(){
    this.commonService.sessionPortalLoad();
    //reconstruct the BOM
    var allLineItemsInCpp=[];
    if(this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy.length > 0){
      for(var ob in this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy){
        allLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy[ob])
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall.length > 0){
      for(var dni in this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall){
        allLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall[dni])
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport.length > 0){
      for(var cs in this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport){
        allLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport[cs])
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide.length > 0){
      for(var iwp in this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide){
        allLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide[iwp])
      }
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.issueFound.length > 0){
      for(var isf in this.commonService.commonMainObj.finalCustomBomPricingData.issueFound){
        allLineItemsInCpp.push(this.commonService.commonMainObj.finalCustomBomPricingData.issueFound[isf])
      }
    }
    allLineItemsInCpp.sort((a, b) => a.itemNo - b.itemNo);
  
    var headerData =["Item#","Manufacturer Part Number","Vendor Part Number","Manufacturer","Footprint","DNI","Quantity","Reference Designators","Customer Will Provide","Description","Alternate MPN"];
    var contentData;
    for(var i in allLineItemsInCpp){
      if(allLineItemsInCpp[i].dni != 'DNI' ){
        this.commonService.commonMainObj.allAvailableComponets.push(allLineItemsInCpp[i].mpn);
      }
      for(var j in this.commonService.commonMainObj.bomLineItemsSavedForCustomCpp){
        if(allLineItemsInCpp[i].itemNo == this.commonService.commonMainObj.bomLineItemsSavedForCustomCpp[j]['imported'].item_num){
          allLineItemsInCpp[i].footprint  = this.commonService.commonMainObj.bomLineItemsSavedForCustomCpp[j]['imported'].footprint;
          allLineItemsInCpp[i].description = this.commonService.commonMainObj.bomLineItemsSavedForCustomCpp[j]['imported'].description;
          allLineItemsInCpp[i].vpn = this.commonService.commonMainObj.bomLineItemsSavedForCustomCpp[j]['imported'].vpn;
          allLineItemsInCpp[i].alternateMpn = allLineItemsInCpp[i].alternateMpn?allLineItemsInCpp[i].alternateMpn:allLineItemsInCpp[i].alternateVendMpn?allLineItemsInCpp[i].alternateVendMpn:'';
          allLineItemsInCpp[i].iWillProvide = allLineItemsInCpp[i].partDetail.pricingDetails[0].pricingInfo.action == 'I WILL PROVIDE'? true:false;
        }
      }
    }
    this.commonService.commonMainObj.finalLineItemsInCustomCPP = allLineItemsInCpp;
    contentData= allLineItemsInCpp.map(({itemNo,mpn,vpn,manufacturer,footprint,dni,qtyperBoard,refDes,iWillProvide,description,alternateMpn}) => [itemNo,mpn,vpn,manufacturer,footprint,dni,qtyperBoard,refDes,iWillProvide,description,alternateMpn]);
    let objData = {
      "header": headerData,
      "content" : contentData
    }
    let formBOMQuoteData = new FormData();
    formBOMQuoteData.append('s3ZipFileName', this.commonService.commonMainObj.s3FileName);
    formBOMQuoteData.append('excelData', JSON.stringify(objData));
    setTimeout(() => {
      this.sendBomDataToAttach(formBOMQuoteData);
    }, 500);
    for(let li in allLineItemsInCpp){
      let actionName = allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo.action;
      let lineItems :any={
        'itemNo': allLineItemsInCpp[li].itemNo,
        'description':allLineItemsInCpp[li].description,
        'dni':allLineItemsInCpp[li].dni,
        "manufacturer": allLineItemsInCpp[li].manufacturer,
        "mpn": allLineItemsInCpp[li].mpn,
        "vpn": allLineItemsInCpp[li].vpn,
        "customerWillProvide": allLineItemsInCpp[li].iWillProvide == true ? 'Yes':'No',
        "footprint": allLineItemsInCpp[li].footprint,
        "qtyperBoard":allLineItemsInCpp[li].qtyperBoard,
        "refDes":allLineItemsInCpp[li].refDes
      }
      if(actionName == 'Issue found'){
        if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId']){
          let issueDesc = '';
          if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 27){
            let altObj = allLineItemsInCpp[li].alternateParts.find((a: { altMPNSource: string; }) => {
              return a.altMPNSource === 'VEND';
            });
            issueDesc =  allLineItemsInCpp[li].mpn  +' is not available. For ease of sourcing, Alternate MPN '+ altObj.mpn +' is suggested.'
          }else if (allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 28){
            issueDesc =  allLineItemsInCpp[li].mpn +' is available but the required Minimum Order Quantity (MOQ) is more than required Qty.'
          }else if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 30){
            if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueName']){
              issueDesc =  allLineItemsInCpp[li].mpn +' is not in stock. Estimated lead time is high.'
            }
          }else if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 51){
            issueDesc =  allLineItemsInCpp[li].mpn  +' can not be identified. Please check whether you have the right MPN.'
          }else if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 52){
            issueDesc =  allLineItemsInCpp[li].mpn  + ' is identified as obsolete.'
          }else if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 53){
            issueDesc =  allLineItemsInCpp[li].mpn +' is not in stock.'
          }
          let bomIssuesObj = {
            "bomComponentId":'',
            "issueId":allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['issueId'],
            "subCategoryIssueId":allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'],
            "issueDetail":issueDesc,
            "isInternal": false,
            "cisMastIssueActionability":{
              "actionable": '1',
              "fyiOnly" : '0'
            },
            "cisMastIssuePricingImpact":{
              "dontKnow": "0",
              "likely": "1",
              "unlikely": "0"
            },
            "cisMastIssueTurntimeImpact":{
              "dontKnow": "0",
              "likely": "1",
              "unlikely": "0"
            }
          }
          lineItems['bomIssueDetails'] = bomIssuesObj
        }
      }else if(actionName == 'CUSTOMER SUPPORT'){
        let bomIssuesObj = {
          "bomComponentId":'',
          "issueId":178,
          "subCategoryIssueId":54,
          "issueDetail":'Customer has asked for Sierra customer service for this MPN '+ allLineItemsInCpp[li].mpn +'. Please assess the request and provide necessary solution.',
          "isInternal":true,
          "cisMastIssueActionability":{
            "actionable": '1',
            "fyiOnly" : '0'
          },
          "cisMastIssuePricingImpact":{
            "dontKnow": "0",
            "likely": "1",
            "unlikely": "0"
          },
          "cisMastIssueTurntimeImpact":{
            "dontKnow": "0",
            "likely": "1",
            "unlikely": "0"
          }
        }
        lineItems['bomIssueDetails'] = bomIssuesObj
      }else if(actionName == 'Okay to Buy'){
        if((allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 27 || allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 30 || allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 51 || allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 52 || allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 53) ||  allLineItemsInCpp[li].isSierraAltselected){
          let issueDesc = '';
          let issueId :any='';
          let issueSubId :any='';
          if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 27){
            let altObj = allLineItemsInCpp[li].alternateParts.find((a: { altMPNSource: string; }) => {
              return a.altMPNSource === 'VEND';
            });
            issueDesc = 'Customer has accepted the alternate MPN '+ altObj.mpn +  '. Please do not post the query again to customer';
            issueId = allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['issueId'];
            issueSubId = allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'];
          }else if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 30){
            if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueName']){
              issueDesc = 'Customer has accepted the long lead time for this MPN'+ allLineItemsInCpp[li].mpn +'. Please do not post the query again to customer'
            }
            issueId = allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['issueId'];
            issueSubId = allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'];
          }
          else if(allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 51 || allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 52 || allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'] == 53){
            issueDesc = 'Customer has accepted the alternate MPN '+ allLineItemsInCpp[li].sierraRecommendedMpn +  '. Please do not post the query again to customer';
            issueId = allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['issueId'];
            issueSubId = allLineItemsInCpp[li].partDetail.pricingDetails[0].pricingInfo['issueSubIssueId']['subIssueId'];
          }
          else if(allLineItemsInCpp[li].isSierraAltselected){
            let altSelectedObj = allLineItemsInCpp[li].alternateParts.find((a: { altMPNSource: string; }) => {
              return a.altMPNSource === 'VEND' || a.altMPNSource === 'SYS';
            });
            issueDesc = 'Customer has accepted the alternate MPN '+ altSelectedObj.mpn +  '. Please do not post the query again to customer';
            issueId = 177;
            issueSubId = 27;
          }
          let bomIssuesObj = {
            "bomComponentId":'',
            "issueId":issueId,
            "subCategoryIssueId":issueSubId,
            "issueDetail":issueDesc,
            "isInternal": true,
            "cisMastIssueActionability":{
              "actionable": '0',
              "fyiOnly" : '1'
            },
            "cisMastIssuePricingImpact":{
              "dontKnow": "0",
              "likely": "1",
              "unlikely": "0"
            },
            "cisMastIssueTurntimeImpact":{
              "dontKnow": "0",
              "likely": "1",
              "unlikely": "0"
            }
          }
          lineItems['bomIssueDetails'] = bomIssuesObj
        }
      }
      if(allLineItemsInCpp[li].alternateParts.length > 0){
        let altVendMpn = '';
        for(var alt in allLineItemsInCpp[li].alternateParts){
          if(allLineItemsInCpp[li].alternateParts[alt].altMPNSource == 'VEND' || (allLineItemsInCpp[li].alternateParts[alt].altMPNSource == 'SYS' && allLineItemsInCpp[li].alternateParts[alt]['partDetail']['pricingDetails'][0]['pricingInfo'].source == 'SSK')){
            altVendMpn = allLineItemsInCpp[li].alternateParts[alt].mpn;
          }
        }
        let bomAlternateMpnObj=[{
          "mpn":altVendMpn,
          "vpn":''
        }]
        lineItems['alternateMpns'] = bomAlternateMpnObj;
      }
      this.commonService.commonMainObj.customBomPriceItems.push(lineItems);
    }
    this.commonService.sessionPortalLoad();
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.loadingShow();
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          this.commonService.loadingHide();
          if(data.status == 1){
            this.router.navigateByUrl('/aditinalComponentDetails')
          }
        },error =>{
          console.log('Error in checking user session', error);
        })
      },2000);
    }else{
      this.router.navigateByUrl('/aditinalComponentDetails')
    }
    var cppLineItemCountObj = {
      "lineItemCount":{
        "okayToBuy":this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy?.length > 0?this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy?.length:'',
        "dni":this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall?.length > 0?this.commonService.commonMainObj.finalCustomBomPricingData.doNotInstall?.length:'',
        "customerSupport":this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport?.length > 0 ? this.commonService.commonMainObj.finalCustomBomPricingData.customerSupport?.length:'',
        "consigned":this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide?.length > 0?this.commonService.commonMainObj.finalCustomBomPricingData.iWillProvide?.length:'',
        "issues":this.commonService.commonMainObj.finalCustomBomPricingData.issueFound?.length >0?this.commonService.commonMainObj.finalCustomBomPricingData.issueFound?.length:''
      }
    }
    this.apiService.updateDetailsToDashboard(this.flowActivityId,cppLineItemCountObj,'ComponentProcurementPage').subscribe((resDatas)=>{
    },err=>{
      console.log(err)
      });
  }

  sendBomDataToAttach(bomData:any){
    this.apiService.generateQuoteBOM(bomData).subscribe((data) =>{
      if (data.success) {
        console.log("DATA SUCCESS", data);
      }
    }, error =>{
      console.log('Bom file saving Error', error);
    })
  }

  sierraRecommandedAltsOnClick(content:any){
    let rearrangedRecommendedArray:any=[];
    // if(this.commonService.commonMainObj.sierraCustomRecommendations.length > 0){
    //   for(var i in this.commonService.commonMainObj.sierraCustomRecommendations){
    //     if(this.commonService.commonMainObj.sierraCustomRecommendations[i].alternateVendMpn == '' && this.commonService.commonMainObj.sierraCustomRecommendations[i].partDetail.pricingDetails[0].pricingInfo.action != 'Issue found'){
    //     // if(this.commonService.commonMainObj.sierraCustomRecommendations[i].partDetail.pricingDetails[0].pricingInfo.action != 'Issue found'){
    //       rearrangedRecommendedArray.push(this.commonService.commonMainObj.sierraCustomRecommendations[i]);
    //     }else if(this.commonService.commonMainObj.sierraCustomRecommendations[i].partDetail.pricingDetails[0].pricingInfo.action == 'Issue found'){
    //       rearrangedRecommendedArray.push(this.commonService.commonMainObj.sierraCustomRecommendations[i]);
    //     }
    //   }
    // }
    // // this.commonService.commonMainObj.finalCustomBomPricingData.recommendations = [];
    // this.commonService.commonMainObj.finalCustomBomPricingData.recommendations = rearrangedRecommendedArray;
    this.sierraRecommandedAlts(content);
  }

  sierraRecommandedAlts(content:any){
    this.commonService.commonMainObj.sierraCustomRecommendations = this.commonService.commonMainObj.finalCustomBomPricingData.recommendations && this.commonService.commonMainObj.finalCustomBomPricingData.recommendations.length>0?this.commonService.commonMainObj.finalCustomBomPricingData.recommendations:[];
    for(var j in this.commonService.commonMainObj.sierraCustomRecommendations){
      this.commonService.commonMainObj.sierraCustomRecommendations[j].checkedModel = false;
      if(this.commonService.commonMainObj.sierraCustomRecommendations[j].partDetail.pricingDetails[0].pricingInfo.issueName != '' && this.commonService.commonMainObj.sierraCustomRecommendations[j].partDetail.pricingDetails[0].pricingInfo.issueName != undefined){
        this.commonService.commonMainObj.sierraCustomRecommendations[j].sierraRecommendedRemarks = this.commonService.commonMainObj.sierraCustomRecommendations[j].partDetail.pricingDetails[0].pricingInfo.issueName;
      }else{
        this.commonService.commonMainObj.sierraCustomRecommendations[j].sierraRecommendedRemarks ='Sierra Recommended Alternate MPN has equal or better tolerance and immediately available';
      }
      this.commonService.commonMainObj.sierraCustomRecommendations[j].sierraRecommendedMpn = this.commonService.commonMainObj.sierraCustomRecommendations[j].alternateParts[0].mpn;
      this.commonService.commonMainObj.sierraCustomRecommendations[j].sierraRecommendedPartDescription = this.commonService.commonMainObj.sierraCustomRecommendations[j].alternateParts[0].partDetail.technicalInfo.vendorDescription;
    }
    if(this.commonService.commonMainObj.finalCustomBomPricingData.recommendations && this.commonService.commonMainObj.finalCustomBomPricingData.recommendations.length>0){
      this.commonService.commonMainObj.sierraCustomRecommendations.sort(function(a:any, b:any) {
        return a.itemNo - b.itemNo;
      });
      let modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class",backdrop : 'static',keyboard : false})
      modalRef.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  selectedSierraSuggItems(){
    let selectedSierraLineItems :any=[];
    if(this.commonService.commonMainObj.sierraCustomRecommendations.length>0){
      this.commonService.commonMainObj.sierraCustomRecommendations.map(function(elem:any){
        if(elem.checkedModel){
          selectedSierraLineItems.push(elem)
        }
      })
    }
    if(selectedSierraLineItems.length == 0){
      this.commonService.alertCall("Alert!", 'Select at least one line item to be replaced.');
      return false;
    }
    let toRemoveSelectedAltIssueLineItem:any=[];
    for(var li in selectedSierraLineItems){
      if(selectedSierraLineItems[li].partDetail.pricingDetails[0].pricingInfo.action == 'Issue found'){
        // remove the selected item from issuesfound       
        this.commonService.commonMainObj.finalCustomBomPricingData['issueFound']= this.commonService.commonMainObj.finalCustomBomPricingData['issueFound'].filter((item: any) => item !== selectedSierraLineItems[li]);
        if(selectedSierraLineItems[li].alternateParts[0].partDetail.pricingDetails[0].pricingInfo.isConsignable == true){
          selectedSierraLineItems[li]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 0, actionName: 'Okay to buy' }, { actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'},{actionId: 3, actionName: 'I WILL PROVIDE'}];
        }else{
          selectedSierraLineItems[li]['partDetail']['pricingDetails'][0]['pricingInfo'].availableActions = [{ actionId: 0, actionName: 'Okay to buy' }, { actionId: 1, actionName: '(DNI) Do Not Install' }, {actionId: 2, actionName: 'CUSTOMER SUPPORT'}];
        }
        selectedSierraLineItems[li]['partDetail']['pricingDetails'][0]['pricingInfo'].selectedAction = 0;
        selectedSierraLineItems[li]['partDetail']['pricingDetails'][0]['pricingInfo'].action='Okay to Buy';
        selectedSierraLineItems[li].alternateVendMpn = selectedSierraLineItems[li].sierraRecommendedMpn;
        selectedSierraLineItems[li].dni="";
        selectedSierraLineItems[li]['partDetail']['pricingDetails'][0]['pricingInfo'].isConsignable = false;
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].push(selectedSierraLineItems[li]) ;
        this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'].sort((a: { itemNo: number; }, b: { itemNo: number; }) => a.itemNo - b.itemNo);
      }else if(selectedSierraLineItems[li].partDetail.pricingDetails[0].pricingInfo.action == 'Okay to Buy'){
        for(var k in this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy']){
          if(selectedSierraLineItems[li].itemNo == this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'][k].itemNo){
            this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'][k].alternateVendMpn = selectedSierraLineItems[li].sierraRecommendedMpn;
            this.commonService.commonMainObj.finalCustomBomPricingData['okayToBuy'][k].isSierraAltselected = true;
          }
        }
      }
      // remove that selected sierra alternate mpn from this.commonService.commonMainObj.sierraCustomRecommendations
      if(this.commonService.commonMainObj.sierraCustomRecommendations.length>0){
        this.commonService.commonMainObj.finalCustomBomPricingData.recommendations= this.commonService.commonMainObj.finalCustomBomPricingData.recommendations.filter((item: any) => item !== selectedSierraLineItems[li]);
      }
    }
    this.modalService.dismissAll('Confirm');
  }


}
